// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","PayBtn":"PayBtn_PayBtn__1sGzr","PayBtnDisabled":"PayBtn_PayBtnDisabled__1wMyj","Icon":"PayBtn_Icon__2FWQF"};